import React, { Component } from 'react'
import { Card, CardLink, CardBody, Form, Input, FormFeedback, FormGroup, Button, UncontrolledCollapse, Row, Col } from 'reactstrap'
import Fetch from '../../Auxiliares/fetch'
import { toast } from 'react-toastify'
import validaciones from '../../Auxiliares/validaciones'

export default class modUsuario extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: this.props.id,
            usuario: this.props.usuario,
            nombre: this.props.nombre,
            ap_paterno: this.props.ap_paterno,
            ap_materno: this.props.ap_materno,
            rfc: this.props.rfc,
            rol: this.props.rol,
            correo: this.props.correo,
            contraseña: '',
            confContraseña: '',
            errors: {}
        }
        this.activar = this.activar.bind(this)
        this.desactivar = this.desactivar.bind(this)

    }

    activar(id) {
        Fetch('/api/updateHabilitar', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id, habilitarUso: true })
        })
            .then(response => {
                this.props.actualizar();
                this.props.cerrar();
            })
            .catch(err => {
                switch (err.status) {

                    case 600:
                        console.log('Error inesperado')
                        break;

                    case 602:
                        console.log('Este usuario no existe')
                        break;

                    default:
                        break;
                }
            })
    }

    desactivar(id) {
        Fetch('/api/updateHabilitar', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: id, habilitarUso: false })
        })
            .then(response => {
                this.props.actualizar();
                this.props.cerrar();
            })
            .catch(err => {
                switch (err.status) {

                    case 600:
                        console.log('Error inesperado')
                        break;

                    case 602:
                        console.log('Este usuario no existe')
                        break;

                    default:
                        break;
                }
            })
    }

    setValue(field, ev) {
        this.setState({ [field]: ev.target.value }, () => {
            let value;
            switch ([field].toString()) {
                case 'nombre':
                    if (validaciones.validar_nombre(this.state.nombre)) {
                        value = validaciones.validar_nombre(this.state.nombre)
                        this.setState(prevState => ({ errors: { ...prevState.errors, nombre: value } }));
                    } else {
                        this.setState({ errors: (delete Array.from(this.state.errors).nombre) });
                    }
                    break;

                case 'ap_paterno':
                    if (validaciones.validar_ap_paterno(this.state.ap_paterno)) {
                        value = validaciones.validar_ap_paterno(this.state.ap_paterno)
                        this.setState(prevState => ({ errors: { ...prevState.errors, ap_paterno: value } }));
                    } else {
                        this.setState({ errors: (delete Array.from(this.state.errors).ap_paterno) });
                    }
                    break;

                case 'ap_materno':
                    if (validaciones.validar_ap_materno(this.state.ap_materno)) {
                        value = validaciones.validar_ap_materno(this.state.ap_materno)
                        this.setState(prevState => ({ errors: { ...prevState.errors, ap_materno: value } }));
                    } else {
                        this.setState({ errors: (delete Array.from(this.state.errors).ap_materno) });
                    }
                    break;

                case 'rfc':
                    if (validaciones.validar_rfc(this.state.rfc)) {
                        value = validaciones.validar_rfc(this.state.rfc)
                        this.setState(prevState => ({ errors: { ...prevState.errors, rfc: value } }));
                    } else {
                        this.setState({ errors: (delete Array.from(this.state.errors).rfc) });
                    }
                    break;

                case 'rol':
                    if (validaciones.validar_rol(this.state.rol)) {
                        value = validaciones.validar_rol(this.state.rol)
                        this.setState(prevState => ({ errors: { ...prevState.errors, rol: value } }));
                    } else {
                        this.setState({ errors: (delete Array.from(this.state.errors).rol) });
                    }
                    break;

                default:
                    break;
            }
        })
    }

    guardar() {
        const { id, usuario, nombre, ap_paterno, ap_materno, rfc, rol, correo, contraseña, confContraseña } = this.state

        if (contraseña) {
            if (contraseña === confContraseña && validaciones.sinErrores(this.state.errors)) {
                Fetch('/api/updateUsuarioPass', {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id, usuario, nombre, ap_paterno, ap_materno, rfc, rol, correo, contraseña })
                }).then(Response => {
                    this.props.actualizar();
                    this.props.cerrar();
                }).catch(err => {
                    switch (err.status) {

                        case 600:
                            toast.error('Error inesperado')
                            break;

                        case 602:
                            toast.error('Este usuario no existe')
                            break;

                        default:
                            break;
                    }
                })
            } else {
                return toast.error("Las contraseñas no coinciden")
            }
        } else {
            if (validaciones.sinErrores(this.state.errors)) {
                Fetch('/api/updateUsuario', {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id, usuario, nombre, ap_paterno, ap_materno, rfc, rol, correo })
                }).then(Response => {
                    this.props.actualizar();
                    this.props.cerrar();
                }).catch(err => {
                    switch (err.status) {

                        case 600:
                            toast.error('Error inesperado')
                            break;
                        
                        case 602:
                            toast.error('Este usuario no existe')
                            break;

                        default:
                            break;
                    }
                })
            }
        }
    }

    render() {
        return (
            <Card className="border-0">
                <CardBody>
                    <Form method="post" encType="multipart/form-data">
                        <FormGroup >
                            <Input className="w-100 font-weight-bold" type="text" onChange={this.setValue.bind(this, "usuario")} placeholder="Usuario" name="usuario" defaultValue={this.state.usuario} />
                            <FormFeedback>{this.state.errors.usuario}</FormFeedback>
                        </FormGroup>

                        <FormGroup >
                            <Input className="w-100" type="text" onChange={this.setValue.bind(this, "nombre")} placeholder="Nombre" name="nombre" defaultValue={this.state.nombre} />
                            <FormFeedback>{this.state.errors.nombre}</FormFeedback>
                        </FormGroup>

                        <FormGroup>
                            <Input className="w-100" type="text" onChange={this.setValue.bind(this, "ap_paterno")} placeholder="Apellido Paterno" name="ap_paterno" defaultValue={this.state.ap_paterno} />
                            <FormFeedback>{this.state.errors.ap_paterno}</FormFeedback>
                        </FormGroup>

                        <FormGroup>
                            <Input className="w-100" type="text" onChange={this.setValue.bind(this, "ap_materno")} placeholder="Apellido Materno" name="ap_materno" defaultValue={this.state.ap_materno} />
                            <FormFeedback>{this.state.errors.ap_materno}</FormFeedback>
                        </FormGroup>

                        <FormGroup>
                            <Input className="w-100" type="text" onChange={this.setValue.bind(this, "rfc")} placeholder="RFC" name="rfc" defaultValue={this.state.rfc} />
                            <FormFeedback>{this.state.errors.rfc}</FormFeedback>
                        </FormGroup>

                        <FormGroup>
                            <Input className="w-100" type="text" onChange={this.setValue.bind(this, "correo")} placeholder="correo" name="correo" defaultValue={this.state.correo} />
                            <FormFeedback>{this.state.errors.correo}</FormFeedback>
                        </FormGroup>

                        <FormGroup>
                            <Input type="select" name="tipo" onChange={this.setValue.bind(this, "rol")} className="w-100" defaultValue={this.state.rol}>
                                <option>auxiliar</option>
                                <option>personal</option>
                                <option>administrador</option>
                            </Input>
                            <FormFeedback>{this.state.errors.rol}</FormFeedback>
                        </FormGroup>
                        <br />

                        <FormGroup>
                            <Row>
                                <Col className="text-left">
                                    <CardLink>
                                        <Button id="pass" color="danger" className="mr-2">Contraseña</Button>
                                    </CardLink>
                                </Col>
                                <Col className="text-right">
                                    {this.props.habilitarUso ? <Button color="primary" onClick={() => this.desactivar(this.props.id)} >Cuenta Activada</Button> : <Button color="secondary" onClick={() => this.activar(this.props.id)}>Cuenta Desactivada</Button>}
                                </Col>
                            </Row>

                            <UncontrolledCollapse toggler="#pass" className="mt-4">
                                <Card>
                                    <CardBody>
                                        <FormGroup >
                                            <Input className="w-100" type="password" onChange={this.setValue.bind(this, "contraseña")} placeholder="Contraseña" name="pass" />
                                        </FormGroup>
                                        <FormGroup >
                                            <Input className="w-100" type="password" onChange={this.setValue.bind(this, "confContraseña")} placeholder="Confirmar Contraseña" name="confPass" />
                                        </FormGroup>
                                    </CardBody>
                                </Card>
                            </UncontrolledCollapse>
                        </FormGroup>
                        <br />
                        <CardLink>
                            <Button color="info" onClick={() => this.guardar()}>Guardar</Button>
                            <Button color="white" onClick={this.props.cerrar} >Cancelar</Button>
                        </CardLink>
                    </Form>
                </CardBody>
            </Card>
        )
    }
}
